;(function() {
  'use strict'

  Controller.$inject = ["$rootScope", "$scope", "$http", "$state", "$timeout", "$window", "$q", "$log", "api", "glAnalytics", "glDialog", "glError", "glUtils", "glPrefs", "configService", "app", "deviceService", "channelService", "surveyShieldService", "responseTypeService", "paramService", "surveysService", "chainService", "userService", "Responder", "promotionsService", "translationService", "surveyGenerator", "websiteService", "aiService", "surveyThemeService"];
  angular.module('app.survey').controller('Survey', Controller)

  /* @ngInject */
  function Controller(
    $rootScope,
    $scope,
    $http,
    $state,
    $timeout,
    $window,
    $q,
    $log,
    api,
    glAnalytics,
    glDialog,
    glError,
    glUtils,
    glPrefs,
    configService,
    app,
    deviceService,
    channelService,
    surveyShieldService,
    responseTypeService,
    paramService,
    surveysService,
    chainService,
    userService,
    Responder,
    promotionsService,
    translationService,
    surveyGenerator,
    websiteService,
    aiService,
    surveyThemeService
  ) {
    var Views = Responder.Views
    var Events = Responder.Events
    var shield = surveyShieldService.forSurvey($state.params.id)
    var INACTIVE_WARNING_MS = 30000
    var INACTIVE_WARNING_TIMEOUT_MS = 10000
    var outlinkPrefs = glPrefs.create('outlink')

    $scope.isProgress = isProgress
    $scope.isMobileNextVisible = isMobileNextVisible
    $scope.isAdmin = userService.hasRole(userService.Roles.ADMIN)
    $scope.surveyGenerator = surveyGenerator
    $scope.restartSurvey = restartSurvey

    $scope.$on(Events.START, onStart)
    $scope.$on(Events.VIEW_CHANGED, onViewChanged)
    $scope.$on(Events.VIEW_COMPLETED, onViewCompleted)
    $scope.$on(Events.SENT, onSent)
    $scope.$on(Events.SENT_ERROR, onSentError)
    $scope.$on(Events.DONE, onDone)

    $scope.$on('$destroy', onDestroy)

    onInit()

    function onInit() {
      $scope.params = new URL(window.location.href).searchParams
      $scope.embedded = $state.params.embedded
      $scope.isTemplate = !!$state.params.template
      $scope.labels = translationService.getDefaultLabels()

      // check for stupid params
      checkForStupidParams()

      if (window.parent) {
        window.addEventListener('message', onParentMessage, false)
      }

      if (!$scope.isTemplate) {
        // get and setup the survey
        loadChannel()
          .then(getSurvey)
          .then(checkAccess)
          .then(getTranslation)
          .then(applyTranslation)
          .then(getTheme)
          .then(applyTheme)
          .then(init)
          .then(loadPriorTags)
          .then(setup)
          .catch(function(error) {
            console.error(error)
            glError.fromStatus(error)
          })
      } else {
        // get and setup the survey template
        surveysService
          .getTemplate($state.params.id)
          .then(getTranslation)
          .then(applyTranslation)
          .then(getTheme)
          .then(applyTheme)
          .then(init)
          .then(setup)
          .catch(function(error) {
            console.error(error)
            glError.fromStatus(error)
          })
      }

      keepActionUpdated()
    }

    function loadChannel() {
      if (!$state.params.channelId) {
        return $q.resolve()
      }
      return channelService
        .get($state.params.channelId)
        .then(function(channel) {
          if (!channel.enabled) {
            return $q.reject({ status: 404 })
          }
          $scope.channel = channel
        })
        .catch(function() {
          return $q.reject({ status: 404 })
        })
    }

    function getSurvey() {
      return surveysService.get($state.params.id)
    }

    function checkAccess(survey) {
      // only allow isArchived surveys to be viewed with readOnly=true
      if (!isPreview() && survey.isArchived) {
        // fake a 404 not found
        return $q.reject({ status: 404 })
      }
      return survey
    }

    function getTranslation(survey) {
      var translationId =
        $state.params.translationId ||
        ($scope.channel && $scope.channel.translationId)
      if (translationId) {
        return translationService
          .getById(translationId)
          .promise.then(function(translation) {
            $scope.translation = translation
            if (translation.language) {
              document.documentElement.lang = translation.language
            }
            return survey
          })
      }
      return $q.resolve(survey)
    }

    function applyTranslation(survey) {
      var translation = $scope.translation
      if (!translation) {
        return $q.resolve(survey)
      }
      var corpus = translationService.corpus(survey, $scope.labels)
      if (translation.type === translation.Types.AUTO) {
        return translationService
          .translate(corpus, translation.language)
          .then(function(newCorpus) {
            translationService.corpus(survey, $scope.labels, newCorpus)
            return survey
          })
      }
      if (translation.type === translation.Types.CUSTOM) {
        var newCorpus = corpus.map(function(item) {
          return translation.mappings[item]
        })
        translationService.corpus(survey, $scope.labels, newCorpus)
        return $q.resolve(survey)
      }
      return $q.resolve(survey)
    }

    function getTheme(survey) {
      var themeId = survey.data.themeId
      if (themeId) {
        return surveyThemeService
          .getById(themeId, survey.ownerId)
          .then(function(theme) {
            $scope.theme = theme
            return survey
          })
      }
      return $q.resolve(survey)
    }

    function applyTheme(survey) {
      var theme = $scope.theme || surveyThemeService.getDefault()
      surveyThemeService.apply(theme)
      return $q.resolve(survey)
    }

    function init(data) {
      var isLoggedIn = userService.loggedIn()
      var isKiosk =
        $scope.channel && $scope.channel.type === $scope.channel.Type.KIOSK
      var isPanel =
        $scope.channel && $scope.channel.type === $scope.channel.Type.PANEL
      var tagQuotas = $scope.channel
        ? $scope.channel.getTagQuotaGroups(data)
        : null
      var tagCounts =
        $scope.channel && !$scope.channel.useGlobalTagCounts
          ? $scope.channel.getTagCounts()
          : data.tagCounts
      var deviceId = deviceService.getId()
      var survey = new Responder(
        data,
        tagQuotas,
        tagCounts,
        isLoggedIn,
        isReadOnly(data),
        isKiosk,
        isPanel,
        $scope.isTemplate,
        deviceId,
        $scope.labels
      )
      $scope.translate =
        $state.params.translate || ($scope.channel && $scope.channel.translate)
      return $q.resolve(survey)
    }

    function setup(survey) {
      app.setTitle(survey.survey.title)
      app.setTags(getTags(survey.survey))

      $scope.survey = survey

      // setup redirects
      setupRedirects()

      // add promotion
      setReward($scope.survey.survey)

      // external panel provider
      checkForExternalPanel()

      // dynata panel channel surveys
      checkForDynataPanel()

      // cint panel
      checkForCintPanel()

      // async pre-check
      precheck()

      // add chain headers
      setChain()

      // check survey shield
      checkSurveyShield()

      // add any dimensions
      setDimensions()

      // show reward
      showReward()

      // show a warning if previewing
      showPreviewAlert()

      // inject tags to responder if Tag Injection feature is enabled
      // inject variables
      injectTagsAndVariables()

      checkOutlink()

      // bind survey validation function with aiService with pre-set identifiers
      bindSurveyValidationFunction()

      return $q.resolve(survey)
    }

    function keepActionUpdated() {
      /**
       * The survey.nextAction() function used to be placed directly into jade templates, eg:
       *
       * survey-next-inline(action='$ctrl.survey.nextAction()' on-next='$ctrl.survey.next()')
       *
       * Which meant each digest cycle it would be called to resolve the current action.
       * This function is expensive, specifically with 1000 pieces of logic it can take up to 10 seconds.
       * To make matters worse, angular digests are quite inefficient so its not uncommon to see 10-20 digests all happen at once.
       *
       * Instead, we use the following code to listen for digest cycles ($scope.$watch) and then
       * use a heuristic to update the action but returned cached actions for the trailing digests.
       *
       * The biggest problem with doing this is when a user clicks two buttons quickly, the second button would get ignored and
       * the action wouldn't reflect the latest.
       * To fix this, we use a timer to run it one more time after digests settle down and some time has passed.
       */
      var didUpdateAction
      function updateAction() {
        if (!$scope.survey) return
        if (didUpdateAction) {
          didUpdateAction = false
          return
        }
        $scope.$applyAsync(function() {
          $scope.survey.action = $scope.survey.nextAction()
        })
        didUpdateAction = true
      }
      var updateActionDebounced = _.debounce(updateAction, {
        leading: true,
        trailing: true,
      })
      $scope.$watch(function() {
        updateActionDebounced()
      })
    }

    function loadPriorTags(survey) {
      var self = this
      var maxPeriod = 0
      var priorTags = []
      survey.priorTags = priorTags
      function checkLogic(logic) {
        logic.forEach(function(logic) {
          logic.conditions.forEach(function(condition) {
            if (condition.type === 'IS_PRIOR_TAGGED') {
              if (condition.period > maxPeriod) {
                maxPeriod = condition.period
              }
            }
          })
        })
      }
      survey.views.forEach(function(view) {
        if (view.question) checkLogic(view.question.logic)
        if (view.section) checkLogic(view.section.logic)
      })
      if (maxPeriod > 0) {
        return $q(function(resolve, reject) {
          var now = moment()
          var maxDate = moment()
            .startOf('day')
            .subtract(maxPeriod)
            .toISOString()
          var filter = ''
          filter += 'glowId eq ' + survey.deviceId
          filter += " and createdAt gte '" + maxDate + "'"
          api.responses
            .listExpanded({ id: survey.id, filter: filter })
            .then(function(responses) {
              responses.forEach(function(response) {
                _.each(response.reportingDimensions.crd, function(value, key) {
                  if (key.startsWith('tag:')) {
                    const date = moment(response.responseCreatedAt)
                    priorTags.push({
                      tag: key.split('tag:')[1],
                      daysAgo: now.diff(date, 'days'),
                    })
                  }
                })
              })
              console.log('priorTags', priorTags)
              resolve(survey)
            })
        })
      }
      return $q.resolve(survey)
    }

    /**
     * Work out the open graph (og) tags for survey sharing
     */
    function getTags(survey) {
      var shareText =
        survey.description || 'Please complete "' + survey.title + '"'
      var shareImageUrl = survey.imageUrl
      var shareUrl

      // Additionally it is possible to set open graph tags
      // via survey.data(.shareText|.shareImageUrl|.shareUrl)
      if (survey.data) {
        shareText = survey.data.shareText || shareText
        shareImageUrl = survey.data.shareImageUrl || shareImageUrl
        shareUrl = survey.data.shareUrl
      }

      return {
        title: survey.title,
        description: shareText,
        image: shareImageUrl,
        url: shareUrl,
      }
    }

    function checkForStupidParams() {
      /**
       * Cint and Dynata have both been known to give us invalid URL's that look like this:
       *
       * ?linkId=[LINK_ID]?CintID=[CINT_ID]
       *
       * instead of this:
       *
       * ?linkId=[LINK_ID]&CintID=[CINT_ID]
       */
      var fixes = []
      $scope.params.forEach(function(value, key) {
        if (value.includes('?') && value.includes('=')) {
          // fix it on the fly
          var split1 = value.split('?')
          var realValue = split1[0]
          fixes.push({ key: key, value: realValue })
          var other = split1[1].split('=')
          fixes.push({ key: other[0], value: other[1] })
          // notify us on Slack
          $http({
            method: 'POST',
            url: configService.getNodeUrl('/alerts'),
            data: {
              type: 'brokenSurveyUrl',
              surveyUrl: window.location.href,
            },
          })
        }
      })
      fixes.forEach(function(fix) {
        $scope.params.set(fix.key, fix.value)
      })
    }

    function setupRedirects() {
      // override with channel redirects if they are enabled
      if ($scope.channel) {
        $scope.survey.redirects = $scope.channel.redirects
      } else {
        $scope.survey.redirects = {
          enabled: false,
          submitLink: null,
          exitLink: null,
          quotaLink: null,
          qualityExitLink: null,
        }
      }
    }

    function setReward(survey) {
      var reward
      var channelReward = $scope.channel && $scope.channel.reward
      var hasRewardCosts =
        survey && survey.rewardResponseCost && survey.rewardExitCost
      if (channelReward && hasRewardCosts) {
        reward = promotionsService.getInfo(
          survey.rewardResponseCost,
          survey.rewardExitCost
        )
      }
      $scope.reward = reward
    }

    function checkForCintPanel() {
      var redirects = $scope.survey.redirects
      var CINT_ID = $scope.params.get('CintID')

      if (
        !CINT_ID ||
        !redirects.enabled ||
        !redirects.submitLink ||
        !redirects.exitLink ||
        !redirects.quotaLink ||
        !redirects.qualityExitLink
      )
        return

      redirects.submitLink = glUtils.addParamsV2(redirects.submitLink, {
        CintID: CINT_ID,
      })

      redirects.exitLink = glUtils.addParamsV2(redirects.exitLink, {
        CintID: CINT_ID,
      })

      redirects.quotaLink = glUtils.addParamsV2(redirects.quotaLink, {
        CintID: CINT_ID,
      })

      redirects.qualityExitLink = glUtils.addParamsV2(
        redirects.qualityExitLink,
        {
          CintID: CINT_ID,
        }
      )

      $scope.survey.respondentId = CINT_ID
      $scope.survey.setDimension(
        $scope.survey.Dimensions.DATA,
        'Panelist ID (CintID)',
        CINT_ID
      )
    }

    function checkForExternalPanel() {
      if ($scope.channel && $scope.channel.provider) {
        var provider = $scope.channel.provider
        var endLinks = provider.generateEndLinks(
          $scope.params,
          $scope.channel.providerValues
        )
        if (!endLinks.valid) {
          return glError.notFound({
            route: glError.Routes.DEFAULT,
            title: 'Sorry!',
            message:
              'Looks like this survey is no longer available. Thank you for your interest in participating.',
          })
        }
        $scope.survey.redirects = {
          enabled: true,
          submitLink: endLinks.submitLink,
          exitLink: endLinks.exitLink,
          quotaLink: endLinks.quotaLink,
          qualityExitLink: endLinks.qualityExitLink,
        }
        $scope.survey.respondentId = provider.getRespondentId($scope.params)
        $scope.survey.setDimension(
          $scope.survey.Dimensions.DATA,
          'Panelist ID',
          $scope.survey.respondentId
        )
        provider.getCaptured($scope.params, function(type, name, value) {
          $scope.survey.setDimension(type, name, value)
        })
      }
    }

    function checkForDynataPanel() {
      // panel overrides the submit/exit redirect urls
      // to conform with Dynata
      var redirects = $scope.survey.redirects
      var channel = $scope.channel
      var PSID = $scope.params.get('psid')
      var PID = $scope.params.get('pid')
      var K2 = $scope.params.get('K2')
      var BASIC = $scope.params.get('basic') || (channel && channel.basic)

      // both medium and basic panel require a psid
      if (!PSID) return

      // add the panel details as a dimension
      $scope.survey.setDimension(
        $scope.survey.Dimensions.DATA,
        'Panelist ID (pid)',
        PID
      )
      $scope.survey.setDimension(
        $scope.survey.Dimensions.DATA,
        'Respondent ID (psid)',
        PSID
      )

      // PID is the panelist's ID
      // PSID represents the project AND panelist
      // PID would have been best for this but PSID is the only one
      // available to both Medium and Basic modes.
      $scope.survey.respondentId = PSID

      // medium mode (integrated through panel channels)
      if (channel && channel.type === channel.Type.PANEL) {
        var endLinks = $scope.channel.panel.generateEndLinks(PSID, PID, K2)
        redirects.enabled = true
        redirects.submitLink = endLinks.complete
        redirects.exitLink = endLinks.screenout
        redirects.quotaLink = endLinks.overquota
        redirects.qualityExitLink = endLinks.qualityExit
      }

      // basic mode  (manual process)
      if (BASIC) {
        redirects.enabled = true
        redirects.submitLink =
          'https://dkr1.ssisurveys.com/projects/end?rst=1&psid=' +
          PSID +
          '&basic=' +
          BASIC
        redirects.exitLink =
          'https://dkr1.ssisurveys.com/projects/end?rst=2&psid=' + PSID
        redirects.quotaLink =
          'https://dkr1.ssisurveys.com/projects/end?rst=3&psid=' + PSID
        redirects.qualityExitLink = $scope.channel.panel.getQualityExitLink(
          redirects.exitLink
        )
      }
    }

    function precheck() {
      /**
       * We allow respondents to continue but in the background
       * we run a check to see if their respondentId will be accepted
       * for this survey+channel. If the check fails we abort
       * and show an error
       */
      var channel = $scope.channel
      var respondentId = $scope.survey.respondentId
      if (!respondentId || !channel) return
      api.audienceChannels
        .preCheck({ id: channel.id, respondentId: respondentId })
        .then(function(resp) {
          console.log('precheck:', resp.allowed ? 'allowed' : 'denied')
          if (resp.allowed) return
          glError.notFound({
            route: glError.Routes.DEFAULT,
            title: 'Sorry!',
            message:
              'Looks like this survey is no longer available. Thank you for your interest in participating.',
          })
        })
        .catch(function(err) {
          // fail silently
          // console.error('Failed to run precheck', err)
        })
    }

    function setChain() {
      // add link to chain (if any)
      var linkId = $state.params.linkId
      if (linkId) {
        chainService.update({ linkId: linkId })
      }

      // add channel to chain (if any)
      if ($scope.channel) {
        chainService.update({ channelId: $scope.channel.id })
      }

      // add chain headers to survey (if any)
      var chainHeader = chainService.header()
      if (chainHeader) {
        $scope.survey.setHeaders({ 'X-Glow-Referral-Chain': chainHeader })
      }
    }

    function isReadOnly(survey) {
      return survey.isArchived || isPreview()
    }

    function isPreview() {
      return $state.params.readOnly === 'true'
    }

    function checkSurveyShield() {
      // error if survey is locked
      if (
        !$scope.survey.isReadOnly &&
        shield.isLocked($state.params.token, $scope.channel)
      ) {
        return glError.notFound({
          route: glError.Routes.DEFAULT,
          title: 'Sorry!',
          message:
            'Looks like this survey is no longer available. Thank you for your interest in participating.',
        })
      }
    }

    function setDimensions() {
      // merge dimensions from url and custom data
      var redirects = $scope.survey.redirects
      var params = _.merge(paramService.get(), $state.params.data)

      if (redirects.exitLink) {
        redirects.exitLink = glUtils.addParamsV2(redirects.exitLink, params.cd)
      }
      if (redirects.submitLink) {
        redirects.submitLink = glUtils.addParamsV2(
          redirects.submitLink,
          params.cd
        )
      }
      if (redirects.quotaLink) {
        redirects.quotaLink = glUtils.addParamsV2(
          redirects.quotaLink,
          params.cd
        )
      }
      if (redirects.qualityExitLink) {
        redirects.qualityExitLink = glUtils.addParamsV2(
          redirects.qualityExitLink,
          params.cd
        )
      }

      // system dimensions
      _.each(params, function(value, key) {
        if (!key.startsWith('rd_')) return
        key = key.split('rd_')[1]
        $scope.survey.setDimension($scope.survey.Dimensions.SYSTEM, key, value)
      })
      _.each(params.rd, function(value, key) {
        $scope.survey.setDimension($scope.survey.Dimensions.SYSTEM, key, value)
      })

      // report dimensions
      _.each(params, function(value, key) {
        if (!key.startsWith('crd_')) return
        key = key.split('crd_')[1]
        $scope.survey.setDimension($scope.survey.Dimensions.REPORT, key, value)
      })
      _.each(params.crd, function(value, key) {
        $scope.survey.setDimension($scope.survey.Dimensions.REPORT, key, value)
      })

      // data dimensions
      _.each(params, function(value, key) {
        if (!key.startsWith('cd_')) return
        key = key.split('cd_')[1]
        $scope.survey.setDimension($scope.survey.Dimensions.DATA, key, value)
      })
      _.each(params.cd, function(value, key) {
        $scope.survey.setDimension($scope.survey.Dimensions.DATA, key, value)
      })

      // product
      var productId = $state.params.product
      if (productId) {
        $scope.survey.setDimension(
          $scope.survey.Dimensions.SYSTEM,
          'productId',
          productId
        )
      }

      // place
      var placeId = $state.params.place
      if (placeId) {
        $scope.survey.setDimension(
          $scope.survey.Dimensions.SYSTEM,
          'placeId',
          placeId
        )
      }
    }

    function setInactiveTimer() {
      clearTimeout($scope.inactiveTimerId)
      if ($scope.view.index > 0) {
        $scope.inactiveTimerId = setTimeout(
          showInactiveWarning,
          INACTIVE_WARNING_MS
        )
      }
    }

    function showInactiveWarning() {
      glDialog
        .confirm(
          'Still there?',
          'This survey will automatically restart soon.',
          {
            cancelTimeout: INACTIVE_WARNING_TIMEOUT_MS,
            locals: {
              cancelText: 'Restart',
              closeText: 'Continue',
            },
          }
        )
        .then(function() {
          setInactiveTimer()
        })
        .catch(function() {
          clearTimeout($scope.inactiveTimerId)
          restartSurvey()
        })
    }

    // TODO: delet this?
    function showReward() {
      // if reward but not logged-in, show dialog
      if (!_.isEmpty($scope.survey.survey.rewards) && !userService.loggedIn()) {
        // TODO: dont't pass the whole bloody scope!?!?!?
        glDialog.show({
          templateUrl: 'survey-reward-dialog.html',
          scope: $scope,
        })
      }
    }

    function showPreviewAlert() {
      if (isPreview() && !$state.params.embedded) {
        glDialog.alert(
          'Survey Preview',
          'You are previewing this survey and your response will not be submitted. ' +
            'If you think your response should be submitted then please contact the survey owner.'
        )
      }
    }

    function injectTagsAndVariables() {
      var injectedTags = []
      var leastFills = []
      var injectedVariables = []

      if ($scope.channel) {
        injectedTags = $scope.channel.injectedTags
        leastFills = $scope.channel.leastFills
        injectedVariables = $scope.channel.injectedVariables
      } else {
        if ($state.params.tags) {
          injectedTags = _($state.params.tags)
            .split(',')
            .map(_.trim)
            .value()
        }
      }

      var tagOps = []
      _.each(injectedTags, function(tag) {
        tagOps.push({
          type: 'ADD',
          tag: tag,
          givenByViewIndex: -1,
        })
      })
      _.each(leastFills, function(leastFill) {
        leastFill.randomize()
        var tagsToAdd = leastFill.getTagsToAdd($scope.survey.tagCounts)
        _.each(tagsToAdd, function(tag) {
          tagOps.push({
            type: 'ADD',
            tag: tag,
            givenByViewIndex: -1,
          })
        })
      })

      // inject the tags
      var isOverQuota = $scope.survey.applyTags(tagOps)
      // boot respondent if over quota
      if (isOverQuota) {
        var currentView = $scope.survey.getView()
        currentView.willHitQuota = true
        $scope.survey.next(_.last($scope.survey.views))
      }
      // inject variables
      $scope.survey.applyVariables(injectedVariables, -1)
    }

    function checkOutlink() {
      console.log('[checkOutlink]')
      var survey = $scope.survey
      // if the respondent is entering the survey with an outlink action and we have some outlink data
      // then inject this into the survey and push them to the outro to submit
      var url = new URL(window.location.href)
      var action = url.searchParams.get('outlink')
      if (action) {
        console.log('[checkOutlink] url has action:', action)
      }
      var override = outlinkPrefs.get('override')
      if (override) {
        console.log(
          '[checkOutlink] prefs has override:',
          JSON.stringify(override, null, 2)
        )
      }
      if (action && override) {
        if (override.data.surveyId !== survey.id) {
          console.log(
            "[checkOutlink] override survey doesn't match current survey"
          )
          return
        }
        console.log(
          '[checkOutlink] both action and override exist and override survey matches this survey'
        )
        survey.outlinkOverride = override
        survey.redirects = override.redirects
        // var currentView = survey.getView()
        if (action === 'submit') {
          override.data.type = responseTypeService.Types.COMPLETE
        }
        if (action === 'exit') {
          override.data.type = responseTypeService.Types.EXIT
          survey.didExit = true
        }
        if (action === 'quota') {
          override.data.type = responseTypeService.Types.OVERQUOTA
          survey.didHitQuota = true
        }
        if (action === 'qualityExit') {
          override.data.type = responseTypeService.Types.QUALITYEXIT
          survey.didQualityExit = true
        }
        console.log(
          '[checkOutlink] override.data.type set to ',
          override.data.type
        )
        console.log('[checkOutlink] skipping to outro!')
        survey.next(_.last(survey.views))
        return
      }
      // if the respondent is entering the survey with an outlink that is immediate, skip directly to the end
      // of the survey
      if (
        survey.outlink &&
        survey.outlink.enabled &&
        survey.outlink.immediate
      ) {
        console.log(
          '[checkOutlink] survey.outlink.immediate is true, skipping to outro!'
        )
        survey.next(_.last(survey.views))
      }
    }

    function bindSurveyValidationFunction() {
      $scope.survey.validateTextAnswer = aiService.validateTextAnswer.bind(
        null,
        $scope.survey.id,
        $scope.survey.respondentId
      )
    }

    function onStart(e, responder) {
      if (!responder.isReadOnly) {
        var label = 'survey: ' + $state.params.id
        glAnalytics.track('Survey', 'started', label)
      }
    }

    function onViewChanged(e, view) {
      $scope.view = null
      // force reload view component by using timeout to simulate a digest
      $timeout(function() {
        $scope.view = view
        $window.scrollTo(0, 0)
        if ($scope.survey && $scope.survey.isKiosk) {
          setInactiveTimer(view)
        }
      })
    }

    function onViewCompleted(e, data) {
      glAnalytics.track('Survey', data.action, data.label, data.value)
    }

    function isProgress() {
      var type = $scope.view && $scope.view.type

      return _.includes([Views.SECTION, Views.QUESTION, Views.PAGE], type)
    }

    function isMobileNextVisible() {
      var type = $scope.view && $scope.view.type
      if (type !== Views.OUTRO) return true

      // IMPORTANT!
      // This need to match with survey-next-inline
      // behaviour on survey-outro component
      var restartBtnShown =
        $scope.view.outro.restartButton || $scope.survey.isReadOnly
      return (
        $scope.view.outro.isShown &&
        !$scope.reward &&
        !restartBtnShown &&
        ($scope.survey.isKiosk ||
          $scope.embedded ||
          $scope.survey.survey.submitRoute)
      )
    }

    function onSent() {
      if (!$scope.survey.isReadOnly) {
        shield.registerResponse(
          $state.params.token,
          $scope.survey.didExit,
          $scope.survey.didHitQuota,
          $scope.survey.didQualityExit,
          $scope.channel
        )
      }

      var nextSurveyId = $scope.survey.survey.data.nextSurveyId
      if (nextSurveyId) {
        return $state.go('app.survey', { id: nextSurveyId }, { reload: true })
      }

      if (!$scope.survey.isReadOnly) {
        var label = 'survey: ' + $state.params.id
        glAnalytics.track('Survey', 'finished', label)
      }

      showShare()
    }

    function onSentError() {
      $scope.survey.prev()
      glDialog.alert('', 'Error sending response. Please try again.')
    }

    function onDone() {
      var data = $scope.survey.survey.data
      var submitRoute = $scope.survey.survey.submitRoute

      if (window.parent) {
        window.parent.postMessage('survey-done-pressed', '*')
      }

      // if we are embedded - restart the survey
      if ($state.params.embedded || $scope.survey.isKiosk) {
        return restartSurvey()
      }

      // if we have a page - go to the crowd invite page

      if (data.pageId) {
        var params = {
          pageId: data.pageId,
          redirect: submitRoute,

          // TODO...
          // userEmail: extractFollowupDetails().email || extractEmailFromTextAnswer()
        }
        glAnalytics.track(
          'Survey',
          'RedirectCrowd',
          'survey:' + $scope.survey.survey.id + ' page:' + data.pageId
        )
        return $state.go('app.portal.crowd', params)
      }

      // anything else - log to sentry and go to www site
      if (!submitRoute) {
        $log.error('respondent redirected to www.glowfeed.com')
        window.location.href = websiteService.getWebsiteUrl()
        return
      }

      if (!submitRoute.match(/^[a-zA-Z]+:\/\//)) {
        submitRoute = 'http://' + submitRoute
      }

      window.location.href = submitRoute
    }

    function showShare() {
      var data = $scope.survey.survey.data
      if (!data.shareText) {
        return
      }

      glDialog.show({
        templateUrl: 'survey-share.html',
        controller: 'SurveyShare',
        escapeToClose: true,
        locals: {
          title: data.shareTitle || 'Share',
          text: data.shareText,
          url: data.shareUrl,
          image: data.shareImageUrl,
        },
      })
    }

    function restartSurvey() {
      clearTimeout($scope.inactiveTimerId)
      $state.reload()
    }

    function onParentMessage(event) {
      var message
      try {
        message = JSON.parse(event.data)
      } catch (err) {
        // fail silently as it must be json
        return
      }
      $scope.$applyAsync(function() {
        var params = $state.params
        if (message.action === 'translationId') {
          params.translationId = message.translationId
          glUtils.changeParams(params)
          $state.reload()
        }
      })
    }

    function onDestroy() {
      if (window.parent) {
        window.removeEventListener('message', onParentMessage, false)
      }
    }
  }
})()
